import { render, staticRenderFns } from "./EventsStudentRegistered.vue?vue&type=template&id=6ca635b8&scoped=true&"
import script from "./EventsStudentRegistered.vue?vue&type=script&lang=js&"
export * from "./EventsStudentRegistered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca635b8",
  null
  
)

export default component.exports